import { faMessageDots as faMessageDotsRegular } from "@fortawesome/sharp-regular-svg-icons";
import { faMessageDots } from "@fortawesome/sharp-solid-svg-icons";
import { Box } from "@mui/material";
import { useIntercom } from "react-use-intercom";

import { Icon } from "@/components/ui-v2";

import { PrimaryNavigationItemBase } from "../../../PrimaryNavigationLinks/components/PrimaryNavigationLink/components/PrimaryNavigationItemBase";

export const IntercomButton = () => {
  const { isOpen } = useIntercom();

  const getLabel = () => {
    return isOpen ? "Close Chat" : "Talk To Us";
  };

  const iconComponent = (
    <Box
      sx={{
        height: 36,
        width: 36,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {!isOpen && <Icon icon={faMessageDotsRegular} />}
      {isOpen && <Icon icon={faMessageDots} />}
    </Box>
  );

  return (
    <PrimaryNavigationItemBase
      as="button"
      id="intercom-button"
      active={isOpen}
      icon={iconComponent}
      label={getLabel()}
      style={{
        width: "100%",
      }}
    />
  );
};
